export const enum UserStatusTranslationKey {
  OnDuty = 'UserStatus.OnDuty',
  Private = 'UserStatus.Private',
  NoStatus = 'UserStatus.NoStatus',
  Available = 'UserStatus.Available',
  NotAvailable = 'UserStatus.NotAvailable',
  OnAssignment = 'UserStatus.OnAssignment',
  ExtraShift = 'UserStatus.ExtraShift',
}

export const UserStatusId = {
  [UserStatusTranslationKey.NoStatus]: 1,
  [UserStatusTranslationKey.Available]: 2,
  [UserStatusTranslationKey.NotAvailable]: 3,
  [UserStatusTranslationKey.OnAssignment]: 4,
  [UserStatusTranslationKey.OnDuty]: 5,
  [UserStatusTranslationKey.ExtraShift]: 6,
  [UserStatusTranslationKey.Private]: 7,
} as const;

export const UserStatusIcons = {
  [UserStatusTranslationKey.NoStatus]: {
    icon: 'cancel_filled',
    color: 'var(--dv-icon-on-brand)',
  },
  [UserStatusTranslationKey.Available]: {
    icon: 'check_circle_filled',
    color: 'var(--dv-icon-success)',
  },
  [UserStatusTranslationKey.NotAvailable]: {
    icon: 'do_not_disturb_on_filled',
    color: 'var(--dv-icon-error)',
  },
  [UserStatusTranslationKey.OnAssignment]: {
    icon: 'do_not_disturb_on_filled',
    color: 'var(--dv-icon-error)',
  },
  [UserStatusTranslationKey.OnDuty]: {
    icon: 'schedule_filled',
    color: 'var(--dv-icon-warning)',
  },
  [UserStatusTranslationKey.ExtraShift]: {
    icon: 'schedule_filled',
    color: 'var(--dv-icon-warning)',
  },
  [UserStatusTranslationKey.Private]: {
    icon: 'eye_off',
    color: 'var(--dv-icon-on-brand)',
  },
} as const;

export const UserStatusById = Object.fromEntries(
  Object.entries(UserStatusId).map(([key, value]) => [value, key])
) as Record<number, UserStatusTranslationKey>;
